module.exports = "<div class=\"form-check\">\n  <label class=\"form-check-label lb_clickable\">\n    <input class=\"form-check-input\" [disabled]=\"disabled\" type=\"checkbox\" [(ngModel)]=\"value\">\n    <div class=\"label-text\">\n      <ng-content></ng-content>\n    </div>\n  </label>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/shared/components/forms/checkbox/checkbox.component.html
// module id = 845
// module chunks = 0